import basic from './common/basic.js';

const state = { selections: [], defaultStyle: { theme: 'default' } };

const getters = {
  ...basic.getters({}),
};

const actions = {
  ...basic.actions({ type: 'elements' }),
};

const module = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations: {},
};

export default module;
